import { render, staticRenderFns } from "./lastetreportTable.vue?vue&type=template&id=22b3184b&scoped=true"
import script from "./lastetreportTable.vue?vue&type=script&lang=js"
export * from "./lastetreportTable.vue?vue&type=script&lang=js"
import style0 from "./lastetreportTable.vue?vue&type=style&index=0&id=22b3184b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b3184b",
  null
  
)

export default component.exports